export class Website {

  public id: number;
  public name: string;
  public site_url: string;
  public title: string;
  public screenShotUrl: string;
  public screenshot: string;
  public cloudflareEnabled: boolean;
  public creationDate: Date;
  public isActive: boolean;
  public adminUrl: string;
  public adminImageOptimizerUrl: string;
  public adminPluginsUrl: string;
  public adminBoosterSettingsPage: string;
  public adminElementorUrl: string;
  public adminEcommerceEmailPreviewUrl: string;
  public adminActivateBoosterUrl: string;
  public adminEcommerceUrls: object;
  public adminFrontUrl: string;
  public adminBackupsUrl: string;
  public adminJobsUrl: string;
  public adminLogsUrl: string;
  public adminSearchAnalyticsUrl: string;
  public adminSearchConsoleUrl: string;
  public adminBuilderCreatePage: string;
  public adminUsersPage: string;
  public ftpSettingsValid: boolean;
  public isLocalhost: boolean;
  public loggedOut: boolean;
  public php_version: boolean;

  public selected: boolean;
  public canActivateServices: boolean;
  public adminSeoOverview: string;
  public adminSearchAnalytics: string;
  public adminSeoRedirects: string;
  public adminSeoSiteMap: string;
  public adminSeoMetaData: string;
  public adminFixIssues: string;
  public platformVersion: string;
  public manualOptimizationStatus: string;
  public siblingId: any;
  public httpsEnabled: number; // TODO
  public isMigrated: boolean;
  public type: string;
  public domain_hash: string;
  public tags: any;
  public tagsDefaultList: any;
  public websiteTags: any;
  public isNetwork: any;
  public parentId: any;
  public children: any[];
  public lastUpdated: any;
  public registeredAt: any;
  public score: any;
  public whiteLabel: any;
  public multisiteType: any;
  public serverType: any;
  public manualMigrationStatus: any;
  public whiteLabled: boolean;
  public migrated_from: any;
  public isStopped: any;
  public hasCopy: boolean;
  public connectedFrom: string;
  public isAiConnected: boolean;
  public isAiBuilderDemo: boolean;
  public managerVersionIO: boolean;
  public managerVersion: string;
  public isEcommerceWebsite: boolean;
  public styles?: { color_pallet: string, font_family: string };
  public builderType: 'wvc' | 'section_based';
  public isWVC: boolean;
  public isSectionBased: boolean;
  public websiteType: string;
}
